var map = {
	"./CowoCB.png": [
		"./src/assets/img/gallery/CowoCB.png",
		"src_assets_img_gallery_CowoCB_png"
	],
	"./HotelLaGrange.png": [
		"./src/assets/img/gallery/HotelLaGrange.png",
		"src_assets_img_gallery_HotelLaGrange_png"
	],
	"./KvarnaSladkyZivot.png": [
		"./src/assets/img/gallery/KvarnaSladkyZivot.png",
		"src_assets_img_gallery_KvarnaSladkyZivot_png"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/img/gallery lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;